import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Card,
  Form,
  Input,
  Modal,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  Spinner,
  TabContent,
  TabPane,
  Table,
} from "reactstrap";
import { getGroupSlotById } from "../store/actions/favoriteAction";
import moment from "moment";
import { getFanQuestions } from "../store/actions/managerAction";
import {
  confirmGroupChat,
  groupRefund,
  sendEmailPaidFanSlots,
  singleRefund,
  getFansRequestsBySlotId,
} from "../store/actions/chatAction";

const ViewBookingGroupModal = (props) => {
  let dispatch = useDispatch();
  let [loader, setLoader] = useState(true);
  useEffect(() => {
    if (props.slotData.id !== "") {
      setLoader(true);
      dispatch(
        getGroupSlotById(props.slotData.id, () => {
          setLoader(false);
        })
      );
    }
  }, [props.slotData.id]);
  let { groupSlotById } = useSelector((state) => state.favorite);
  const filteredConfirm = groupSlotById.filter(
    (items) => !items.payments.is_refunded
  );
  const filteredRefund = groupSlotById.filter(
    (items) => items.payments.is_refunded
  );
  let { fanQuestions } = useSelector((state) => state.manager);
  let { slotsFansQuestionRequests } = useSelector((state) => state.chat);
  const [openModal, setOpenModal] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  let [questionLoader, setQuestionLoader] = useState(false);
  const toggle = () => {
    setOpenModal(!openModal);
  };
  const toggle2 = () => {
    setOpenModal2(!openModal2);
    dispatch(getFansRequestsBySlotId(props.slotData.id));
  };
  const handelCheckQuestion = (items) => {
    toggle();
    setQuestionLoader(true);
    dispatch(
      getFanQuestions(items.email, () => {
        setQuestionLoader(false);
      })
    );
  };
  const handelSingleRefund = (items) => {
    let data = {
      slotId: props.slotData.id,
      fanId: items.id,
    };
    dispatch(singleRefund(data));
  };
  const [activeTab, setActiveTab] = useState("Confirm");
  const toggled = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const [confirmLoader, setConfirmLoader] = useState(false);
  const [refundLoader, setRefundLoader] = useState(false);
  const handelConfirm = () => {
    setConfirmLoader(true);
    dispatch(
      confirmGroupChat(props.slotData.id, () => {
        props.handelViewBookingGroupModal();
        setConfirmLoader(false);
      })
    );
  };
  const handelRefund = () => {
    setRefundLoader(true);
    dispatch(
      groupRefund(props.slotData.id, () => {
        props.handelViewBookingGroupModal();
        setRefundLoader(false);
      })
    );
  };
  const handelClose = () => {
    props.handelViewBookingGroupModal();
    setRefundLoader(false);
    setConfirmLoader(false);
  };

  const [message, setMessage] = useState({
    openModal: false,
    text: "",
    btnLoader: false,
  });
  const messageModal = () => {
    setMessage((prev) => ({
      ...prev,
      openModal: !prev.openModal,
    }));
  };
  const handelInput = (e) => {
    setMessage((prev) => ({
      ...prev,
      text: e.target.value,
    }));
  };
  const sendMessage = (e) => {
    e.preventDefault();
    setMessage((prev) => ({
      ...prev,
      btnLoader: true,
    }));
    let obj = {
      id: props.slotData.id,
      text: message.text,
    };
    dispatch(
      sendEmailPaidFanSlots(obj, () => {
        setMessage({
          openModal: false,
          text: "",
          btnLoader: false,
        });
      })
    );
  };

  return (
    <>
      <Modal
        isOpen={props.ShowViewBookingGroupModal}
        toggle={props.handelViewBookingGroupModal}
        size="xl"
        top="true"
        backdrop="static"
        keyboard={false}
      >
        <ModalBody>
          <Card className="pb-2">
            {loader ? (
              <div className="spinner-border text-primary loader mx-auto my-4"></div>
            ) : (
              <>
                <Nav
                  className="d-flex justify-content-start text-dark reponsive-nav-tabs"
                  tabs
                >
                  <NavItem className="cursor-pointer">
                    <NavLink
                      className={
                        activeTab === "Confirm"
                          ? " bg-primary text-white py-2 px-3 "
                          : " py-2"
                      }
                      onClick={() => {
                        toggled("Confirm");
                      }}
                    >
                      <h5 className="m-0">Confirm</h5>
                    </NavLink>
                  </NavItem>
                  <NavItem className="cursor-pointer">
                    <NavLink
                      className={
                        activeTab === "Refund"
                          ? " bg-primary text-white py-2 px-3"
                          : " py-2"
                      }
                      onClick={() => {
                        toggled("Refund");
                      }}
                    >
                      <h5 className="m-0">Refund</h5>
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab} className="px-3">
                  <TabPane tabId="Confirm">
                    <Table className="table align-items-center mt-4" responsive>
                      <thead>
                        <tr>
                          <th scope="col" className="custom-table-heading">
                            Fan Name
                          </th>
                          <th scope="col" className="custom-table-heading">
                            Fan Email
                          </th>
                          <th scope="col" className="custom-table-heading">
                            Payment Date
                          </th>
                          <th scope="col" className="custom-table-heading">
                            Paid Amount
                          </th>
                          <th scope="col" className="custom-table-heading">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredConfirm.length > 0 ? (
                          filteredConfirm.map((items, index) => {
                            return (
                              <tr key={index}>
                                <td className="custom-table-text">
                                  {items.name}
                                </td>
                                <td className="custom-table-text">
                                  {items.email}
                                </td>
                                <td className="custom-table-text">
                                  {moment
                                    .unix(items.payments.payment_date.seconds)
                                    .format("MMM-DD-YYYY")}
                                </td>
                                <td className="custom-table-text">
                                  {items.paidAmount}$
                                </td>
                                <td className="custom-table-text">
                                  {props.type == "manager" && (
                                    <Button
                                      onClick={() => handelCheckQuestion(items)}
                                      color="primary"
                                      className="mr-2"
                                    >
                                      view Fan Questions
                                    </Button>
                                  )}
                                  <Button
                                    color="danger"
                                    disabled={
                                      props.slotData.status == "booked" ||
                                      props.slotData.is_refunded ||
                                      items.btnLoader
                                    }
                                    onClick={() => handelSingleRefund(items)}
                                  >
                                    {items.btnLoader ? (
                                      <i className="spinner-border spinner-border-sm text-white"></i>
                                    ) : (
                                      "Refund"
                                    )}
                                  </Button>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td className="custom-table-text">N/A</td>
                            <td className="custom-table-text">N/A</td>
                            <td className="custom-table-text">N/A</td>
                            <td className="custom-table-text">N/A</td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </TabPane>
                  <TabPane tabId="Refund">
                    <Table className="table mt-4 align-items-center" responsive>
                      <thead>
                        <tr>
                          <th scope="col" className="custom-table-heading">
                            Name
                          </th>
                          <th scope="col" className="custom-table-heading">
                            Email
                          </th>
                          <th scope="col" className="custom-table-heading">
                            Payment Date
                          </th>
                          <th scope="col" className="custom-table-heading">
                            Paid Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredRefund.length > 0 ? (
                          filteredRefund.map((items, index) => {
                            return (
                              <tr key={index}>
                                <td className="custom-table-text">
                                  {items.name}
                                </td>
                                <td className="custom-table-text">
                                  {items.email}
                                </td>
                                <td className="custom-table-text">
                                  {moment
                                    .unix(items.payments.payment_date.seconds)
                                    .format("MMM-DD-YYYY")}
                                </td>
                                <td className="custom-table-text">
                                  {items.paidAmount}$
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td className="custom-table-text">N/A</td>
                            <td className="custom-table-text">N/A</td>
                            <td className="custom-table-text">N/A</td>
                            <td className="custom-table-text">N/A</td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </TabPane>
                </TabContent>
              </>
            )}
          </Card>
          <div className="mt-3 d-flex flex-column flex-sm-row justify-content-end">
            <Button
              color="primary"
              disabled={
                props.slotData.status == "booked" ||
                props.slotData.is_refunded ||
                confirmLoader ||
                refundLoader ||
                filteredConfirm.length == 0
              }
              className="mr-0 mr-sm-2 mb-2 mb-sm-0"
              onClick={handelConfirm}
            >
              {confirmLoader ? (
                <i className="spinner-border spinner-border-sm text-white"></i>
              ) : (
                "Confirm"
              )}
            </Button>
            <Button
              color="danger"
              disabled={
                props.slotData.status == "booked" ||
                props.slotData.is_refunded ||
                confirmLoader ||
                refundLoader ||
                filteredConfirm.length == 0
              }
              className="mr-0 mr-sm-2 mb-2 mb-sm-0"
              onClick={handelRefund}
            >
              {refundLoader ? (
                <i className="spinner-border spinner-border-sm text-white"></i>
              ) : (
                "Refund"
              )}
            </Button>
            {props.slotData.participants && (
              <>
                <Button
                  color="primary"
                  className="mr-0 mr-sm-2 mb-2 mb-sm-0"
                  onClick={messageModal}
                >
                  message
                </Button>
                <Button
                  color="primary"
                  className="mr-0 mr-sm-2 mb-2 mb-sm-0"
                  onClick={toggle2}
                >
                  Requests
                </Button>
              </>
            )}
            <Button
              color="primary"
              className="mb-2 mb-sm-0"
              onClick={handelClose}
            >
              Close
            </Button>
          </div>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={message.openModal}
        toggle={messageModal}
        size="lg"
        top="true"
      >
        <ModalBody>
          <Form onSubmit={sendMessage}>
            <Input
              type="textarea"
              name="messageText"
              value={message.text}
              onChange={handelInput}
            />

            <div className="text-right mt-3 d-flex flex-column flex-sm-row justify-content-end">
              <Button
                color="primary"
                disabled={message.btnLoader}
                className="mr-0 mr-sm-2 mb-2 mb-sm-0"
                type="Submit"
              >
                {message.btnLoader ? <Spinner size="sm" /> : "Send"}
              </Button>
              <Button
                color="primary"
                className="mb-2 mb-sm-0"
                onClick={messageModal}
              >
                Close
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
      <Modal isOpen={openModal} toggle={toggle} size="lg" top="true">
        <ModalBody>
          <Card className="p-2">
            {questionLoader ? (
              <div className="spinner-border text-primary loader mx-auto my-4"></div>
            ) : (
              <Table className="table align-items-center" responsive>
                <thead>
                  <tr>
                    <th scope="col" className="custom-table-heading">
                      Question
                    </th>
                    <th scope="col" className="custom-table-heading">
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {fanQuestions.length > 0 ? (
                    fanQuestions.map((items, index) => {
                      return (
                        <tr key={index}>
                          <td className="custom-table-text">
                            {items.description}
                          </td>
                          <td className="custom-table-text">{items.status}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td className="custom-table-text">N/A</td>
                      <td className="custom-table-text">N/A</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            )}
          </Card>
          <div className="text-right mt-3">
            <Button color="primary" onClick={toggle}>
              Close
            </Button>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={openModal2} toggle={toggle2} size="lg" top="true">
        <ModalBody>
          <div className="text-left mt-3">
            <Card className="p-2">
              {questionLoader ? (
                <div className="spinner-border text-primary loader mx-auto my-4"></div>
              ) : (
                <Table className="table align-items-center" responsive>
                  <thead>
                    <tr>
                      <th scope="col" className="custom-table-heading">
                        Fan Name
                      </th>
                      <th scope="col" className="custom-table-heading">
                        Fan Email
                      </th>
                      <th scope="col" className="custom-table-heading">
                        Question
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {slotsFansQuestionRequests.length > 0 ? (
                      slotsFansQuestionRequests.map((items, index) => {
                        return (
                          <tr key={index}>
                            <td className="custom-table-text">
                              {items.fan.name}
                            </td>
                            <td className="custom-table-text">
                              {items.fan.email}
                            </td>
                            <td className="custom-table-text">
                              {items.question}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td className="custom-table-text">N/A</td>
                        <td className="custom-table-text">N/A</td>
                        <td className="custom-table-text">N/A</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              )}
            </Card>
            <div className="text-right mt-3">
              <Button color="primary" onClick={toggle2}>
                Close
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ViewBookingGroupModal;
